<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import DefineValidation from '@services/validation/DefineValidation'
const router = useRouter()
const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  return {
    nowPassword: modules.string().required().min(6).max(20).label('現在のログインパスワード'),
    newPassword: modules.string().required().min(6).max(20).label('新しいログインパスワード'),
    newPasswordConfirm: modules.string().required().oneOf([modules.ref('newPassword'), null], '入力した新しいログインパスワードと一致しません。')
  }
})

const formItems = [
  {
    id: 'newPassword',
    type: 'password',
    label: '新パスワード',
    placeholder: ''
  },
  {
    id: 'newPasswordConfirm',
    type: 'password',
    label: '新パスワード（確認）',
    placeholder: ''
  }
]

const sendButtonDisabled = computed(() => {
  return !(meta.value.valid && meta.value.dirty && !pendingSendForm.value)
})

const showErrorModal400 = ref(false)
const showCompleteModal = ref(false)
const closeCompleteModal = () => {
  router.push({ name: 'Account' })
  showCompleteModal.value = false
}

const pendingSendForm = ref(false)
const sendForm = handleSubmit(async (values) => {
  pendingSendForm.value = true
  // todoパスワードリマインダー
  pendingSendForm.value = false
})

</script>

<template>
  <section class="l-page">
    <div class="l-page__wrapper">
      <div class="c-compBox">
        <div class="c-compBox__media">
          <i class="icon-password" />
        </div>
      </div>
      <form @submit.prevent="sendAccountForm">
        <div class="c-compBox">
          <div
            v-for="item in formItems"
            :key="item.id"
            class="p-form-field"
          >
            <label
              :for="item.id"
              class="c-input-label"
            ><span class="c-form-required">必須</span>
              {{ item.label }}</label>
            <input
              :id="item.id"
              v-model="models[item.id].value"
              :type="item.type"
              :class="`c-input-${item.type}`"
              :placeholder="item.placeholder"
              :disabled="item.id === 'email'"
              autocomplete="off"
            >
            {{ errors[item.id] }}
          </div>
        </div>
        <button
          type="submit"
          class="c-button c-button--medium c-button--yellow"
        >
          変更
        </button>
      </form>
    </div>
  </section>
</template>

<style scoped lang="scss">

</style>
